import React, { Suspense, lazy, useEffect, useState } from "react";
import "../assets/tailwindcss/t-common-page.scss";

/**
 * lottie-web is 300KB and the animation JSON another 72KB. This component is
 * the App-level Suspense fallback, so importing either statically pulled both
 * into the initial bundle - 372KB that every customer downloaded before the
 * first paint, purely so a loading animation could play.
 *
 * Both are fetched on demand instead. The branded animation still plays; it
 * just arrives a frame or two later, behind the same dimmed overlay, with a
 * lightweight CSS mark holding the space until it does.
 */
const Lottie = lazy(() => import("lottie-react"));

const FlymyaIconLoading = (props) => {
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    let active = true;
    import("../lotties/loading_animation.json")
      .then((mod) => {
        if (active) setAnimationData(mod.default || mod);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="t-loadingGifDiv fixed inset-0 z-[9999] flex flex-col justify-center items-center bg-black/30">
      {animationData ? (
        <Suspense fallback={<span className="fm-loading-mark" />}>
          <Lottie animationData={animationData} loop={true} />
        </Suspense>
      ) : (
        <span className="fm-loading-mark" />
      )}
      {props?.loadingMessage && (
        <p className="text-[17px] text-white">{props?.loadingMessage}</p>
      )}
    </div>
  );
};

export default FlymyaIconLoading;
